<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="general"
          title="Project Data"
          text="List of Prospective Project(s)"
        >
          <v-layout
            row
            wrap>
            <v-flex
              xs12
              sm6
              md6
            >
              <v-text-field
                v-model="search"
                prepend-icon="search"
                label="Search"
                placeholder="Search all by Project Ref/ Company/ Customer/ Name"
                clearable
                single-line
                hide-details/>
            </v-flex>
            <!--            <v-flex-->
            <!--              xs12-->
            <!--              sm6-->
            <!--              md6-->
            <!--            >-->
            <!--              <v-select-->
            <!--                v-model="searchBy.progress"-->
            <!--                :items="progressCalcList"-->
            <!--                menu-props="auto"-->
            <!--                label="Progress"-->
            <!--                input-value="-ALL-"-->
            <!--                placeholder="Select..."-->
            <!--              > &lt;!&ndash; TODO: &ndash;&gt;-->
            <!--                <template v-slot:label>-->
            <!--                  Progress <v-icon style="vertical-align: middle">search</v-icon>-->
            <!--                </template>-->
            <!--                <template v-slot:item="data">-->
            <!--                  {{ data.item == 0 ? '-All-' : data.item + '%' }}-->
            <!--                </template>-->
            <!--                <template v-slot:selection="data">-->
            <!--                  {{ data.item == 0 ? '-All-' : data.item + '%' }}-->
            <!--                </template>-->
            <!--              </v-select>-->
            <!--            </v-flex>-->
            <v-flex
              xs6
              sm3
              md3
            >
              <v-text-field
                v-model="searchBy.pctgGte"
                prepend-icon="search"
                prepend-inner-icon="mdi-code-greater-than-or-equal"
                label="Progress (<=) greater than equal"
                type="number"
                placeholder="Percentage greater than equal"
                hide-details/>
            </v-flex>
            <v-flex
              xs6
              sm3
              md3
            >
              <v-text-field
                v-model="searchBy.pctgLte"
                prepend-icon="search"
                prepend-inner-icon="mdi-code-less-than-or-equal"
                label="Progress (<=) less than equal"
                type="number"
                placeholder="Percentage less than equal"
                hide-details/>
            </v-flex>
          </v-layout>
          <v-dialog
            v-model="dialog"
            persistent
            max-width="800px">
            <!--            <template v-slot:activator="{ on }">-->
            <!--              <v-btn-->
            <!--                color="general"-->
            <!--                class="mb-2"-->
            <!--                dark-->
            <!--                v-on="on" >New</v-btn>-->
            <!--            </template>-->
            <v-form
              id="form1-vue"
              ref="form1"
              v-model="valid1"
              :lazy-validation="lazyValidation1"
            >
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-text-field
                          v-model="editedItem.refNo"
                          :rules="[rules.required]"
                          label="Ref No"
                          disabled
                          readonly
                          class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4>
                        <v-autocomplete
                          v-model="editedItem.customer.company"
                          :items="companies"
                          :rules="[rules.required]"
                          :search-input.sync="searchCompany"
                          hide-no-data
                          placeholder="type 3 words to search..."
                          label="Company *"
                          item-text="name"
                          item-value="id"
                          return-object
                          required
                          @input="getCustomers"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-select
                          v-show="showCustomerSelect"
                          :items="customers"
                          v-model="editedItem.customerSelect"
                          :rules="[rules.required]"
                          required
                          menu-props="auto"
                          item-text="name"
                          item-value="id"
                          label="Customer *"
                          return-object
                          placeholder="Select Company First"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          :rules="[rules.required]"
                          label="Project Name *"
                          required
                          class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-textarea
                          v-model="editedItem.desc"
                          label="Description"
                          counter
                          required
                          clearable
                          class="blue-input"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-select
                          v-model="editedItem.phase"
                          :items="projectPhase"
                          :rules="[rules.required]"
                          menu-props="auto"
                          label="Phase *"
                          required
                          class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-text-field
                          v-model="editedItem.quota"
                          :rules="[rules.number,rules.required]"
                          label="Quota Visit *"
                          required
                          class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-text-field
                          v-model="editedItem.pic"
                          label="Project PIC"
                          class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md4
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="computedDateFormatted"
                              :rules="[rules.required]"
                              label="Due Date *"
                              hint="DD/MM/YYYY"
                              required
                              persistent-hint
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="editedItem.dueDate"
                            no-title
                            @input="menu2 = false"/>
                        </v-menu>
                      </v-flex>
                      <v-flex
                        xs12
                        sm8
                        md8
                      >
                        <v-text-field
                          v-model="editedItem.docLink"
                          label="Project Link URL"
                          class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm4
                        md4
                      >
                        <v-text-field
                          v-model="editedItem.addInfo"
                          label="Additional Info"
                          class="blue-input"/>
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="red darken-1"
                    flat
                    @click="close">Cancel
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    color="green darken-1"
                    flat
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <!--          <v-dialog-->
          <!--            v-model="dialog2"-->
          <!--            persistent-->
          <!--            max-width="300px">-->
          <!--            <v-form-->
          <!--              id="form2-vue"-->
          <!--              ref="form2"-->
          <!--              v-model="valid2"-->
          <!--              :lazy-validation="lazyValidation2"-->
          <!--            >-->
          <!--              <v-card>-->
          <!--                <v-card-text>-->
          <!--                  <v-container grid-list-md>-->
          <!--                    <v-layout wrap>-->
          <!--                      <v-flex-->
          <!--                        xs12-->
          <!--                        sm12-->
          <!--                        md12-->
          <!--                      >-->
          <!--                        <v-select-->
          <!--                          v-model="editedItem.phase"-->
          <!--                          :items="projectPhase"-->
          <!--                          :rules="[rules.required]"-->
          <!--                          menu-props="auto"-->
          <!--                          label="Phase *"-->
          <!--                          required-->
          <!--                          class="blue-input"/>-->
          <!--                      </v-flex>-->
          <!--                      <v-flex-->
          <!--                        xs12-->
          <!--                        sm12-->
          <!--                        md12-->
          <!--                      >-->
          <!--                        <v-text-field-->
          <!--                          v-model="editedItem.docLink"-->
          <!--                          :rules="[rules.required]"-->
          <!--                          label="Project Link URL"-->
          <!--                          required-->
          <!--                          class="blue-input"/>-->
          <!--                      </v-flex>-->
          <!--                    </v-layout>-->
          <!--                  </v-container>-->
          <!--                </v-card-text>-->
          <!--                <v-card-actions>-->
          <!--                  <v-spacer/>-->
          <!--                  <v-btn-->
          <!--                    color="red darken-1"-->
          <!--                    flat-->
          <!--                    @click="close">Cancel-->
          <!--                  </v-btn>-->
          <!--                  <v-btn-->
          <!--                    :disabled="!valid2"-->
          <!--                    color="green darken-1"-->
          <!--                    flat-->
          <!--                    @click="save"-->
          <!--                  >-->
          <!--                    Save-->
          <!--                  </v-btn>-->
          <!--                </v-card-actions>-->
          <!--              </v-card>-->
          <!--            </v-form>-->
          <!--          </v-dialog>-->

          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="DataList"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsAmount"
            :total-items="totalRows"
            dense
            expand
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr
                class="expandable"
                @click.stop=" (props.expanded = !props.expanded)">
                <td class="justify-center ">
                  <!--                  <v-icon-->
                  <!--                    class="mr-2"-->
                  <!--                    @click.stop="updatePhase(props.item)">mdi-update</v-icon>-->
                  <!--                  <v-icon-->
                  <!--                    @click.stop="dialogDeleteShow(props.item)">delete-->
                  <!--                  </v-icon>-->
                  <v-icon
                    class="mr-2"
                    medium
                    @click.stop="editItem(props.item)">edit
                  </v-icon>
                  <v-icon
                    @click.stop="downloadBOMList(props.item)">mdi-file-excel
                  </v-icon>
                </td>
                <td>{{ props.item.dueDate }}</td>
                <td>
                  <router-link
                    :to="routeLinkTo(props.item)"
                    target="_blank"
                    @click.native.stop>{{ props.item.refNo }}</router-link></td>
                <td>{{ props.item.customer.company.name }}</td>
                <td>{{ props.item.addInfo }}</td>
                <td>{{ props.item.customer.name }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.desc }}</td>
                <td>{{ props.item.quota }}</td>
                <td>{{ props.item.visitDetail ? props.item.visitDetail.length : '' }}</td>
                <td>{{ props.item.pic }}</td>
                <td>{{ props.item.percentage }}%</td>
                <td v-if="hasDocLink(props.item)">
                  <a
                    :href="props.item.docLink"
                    target="_blank">
                    {{ props.item.phase }}</a>
                </td>
                <td v-else>{{ props.item.phase }}</td>
                <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
                <td>{{ props.item.lastUpdateBy }}</td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-flex mx-3>
                <v-data-table
                  id="projectvisitlist"
                  :headers="headerVisit"
                  :items="props.item.visitDetail || []"
                  hide-actions
                  dense
                >
                  <template v-slot:items="props">
                    <tr>
                      <td>{{ props.item.visitDate }}</td>
                      <td v-if="hasAttachUrl(props.item)">
                        <a
                          :href="props.item.attachUrl"
                          target="_blank">
                          {{ userLoginMap[props.item.username] }}</a></td>
                      <td v-else>{{ userLoginMap[props.item.username] }}</td>
                      <td class=""> {{ toTimeFormat(props.item.timeStart) }} - {{ toTimeFormat(props.item.timeEnd) }}</td>
                      <td class="">{{ props.item.activity }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <!--                <v-data-iterator-->
                <!--                  :items="props.item.visitDetail || []"-->
                <!--                  content-tag="v-layout"-->
                <!--                  hide-actions-->
                <!--                  row-->
                <!--                  wrap-->
                <!--                >-->

                <!--                  <template v-slot:item="props">-->
                <!--                    <v-flex-->
                <!--                      xs4-->
                <!--                      sm3-->
                <!--                      md2-->
                <!--                    >-->
                <!--                      <v-card>-->
                <!--                        <v-list dense>-->
                <!--                          <v-list-tile>-->
                <!--                            <v-list-tile-content>Visit On:</v-list-tile-content>-->
                <!--                            <v-list-tile-content class="align-end">{{ props.item.visitDate }}</v-list-tile-content>-->
                <!--                          </v-list-tile>-->
                <!--                          <v-list-tile>-->
                <!--                            <v-list-tile-content>Visit By:</v-list-tile-content>-->
                <!--                            <v-list-tile-content class="align-end">{{ props.item.username }}</v-list-tile-content>-->
                <!--                          </v-list-tile>-->
                <!--                          <v-list-tile>-->
                <!--                            <v-list-tile-content>Time Start-End:</v-list-tile-content>-->
                <!--                            <v-list-tile-content class="align-end">-->
                <!--                              {{ toTimeFormat(props.item.timeStart) }} - {{ toTimeFormat(props.item.timeEnd) }}-->
                <!--                            </v-list-tile-content>-->
                <!--                          </v-list-tile>sho-->
                <!--                        </v-list>-->
                <!--                      </v-card>-->
                <!--                    </v-flex>-->
                <!--                  </template>-->

                <!--                </v-data-iterator>-->
              </v-flex>
            </template>
          </v-data-table>

          <v-dialog
            v-model="dialogDelete"
            max-width="400px">
            <v-card>
              <v-card-title class="headline">System Message Confirmation</v-card-title>
              <v-card-text>
                Are you sure want to remove this record? <br>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="red darken-1"
                  text
                  flat
                  @click="dialogDelete = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  flat
                  @click="deleteItem(deleteItemRecord)"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </material-card>
      </v-flex>

    </v-layout>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-icon
        size="16"
        @click="snack = false"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>
</template>
<script>
  import displayFormatterMixins from './../../mixins/displayFormatterMixins'
  import axios from 'axios'

  export default {
    name: 'Project',
    mixins: [displayFormatterMixins],
    data: () => ({
      projectPhase: [
        'PREPARATION_COMPONENT', 'ASSEMBLY_PANEL', 'SETTING_AND_PROGRAMMING',
        'FACTORY_AUTOMATION_TEST', 'SHIPMENT_MACHINE', 'INSTALLATION', 'TRIAL',
        'COMMISSIONING'
      ],
      progressCalcList: [
        0, 12.5, 25, 37.5, 50, 62.5, 75, 87.5, 100
      ],
      menu: false,
      mixins: [displayFormatterMixins],
      snack: false,
      snackText: '',
      snackColor: '',
      dialog: false,
      valid1: false,
      lazyValidation1: false,
      dialog2: false,
      valid2: false,
      lazyValidation2: false,
      showCustomerSelect: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        desc: '',
        refNo: 'AUTO GENERATE',
        dueDate: '',
        quota: '',
        pic: '',
        phase: 'PREPARATION_COMPONENT',
        docLink: '',
        customer: {
          name: '',
          company: {
            id: null,
            name: ''
          }
        }
      },
      defaultItem: {
        id: null,
        name: '',
        desc: '',
        refNo: 'AUTO GENERATE',
        dueDate: '',
        quota: '',
        pic: '',
        phase: 'PREPARATION_COMPONENT',
        docLink: '',
        customer: {
          name: '',
          company: {
            id: null,
            name: ''
          }
        }
      },
      rules: {
        required: value => !!value || 'Required',
        number: value => !isNaN(value) || 'Must be numeric',
        time: value => {
          // ignore `:` masked already
          const pattern = /^([0-1]?[0-9]|2[0-4])([0-5][0-9])(:[0-5][0-9])?$/
          return !value || pattern.test(value) || 'Invalid 24h time format'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
      },
      companies: [],
      customers: [],
      pagination: {},
      DataList: [],
      userLoginMap: Map,
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Due Date', value: 'dueDate' },
        { text: 'Project Ref', value: 'refNo' },
        { text: 'Company', value: 'customer.company.id' },
        { text: 'Add. Info', value: 'addInfo' },
        { text: 'Customer', value: 'customer.customer.id' },
        { text: 'Name', value: 'name' },
        { text: 'Desc', value: 'desc' },
        { text: 'Quota', value: 'quota' },
        { text: 'Total Realized', value: '', sortable: false },
        { text: 'PIC', value: 'pic' },
        { text: 'Progress', value: 'percentage' },
        { text: 'Phase', value: 'phase' },
        { text: 'Update Date Time', value: 'lastUpdateDate' },
        { text: 'Update By', value: 'lastUpdateBy' }
      ],
      headerVisit: [
        { text: 'Visit On', value: 'visitDate', sort: 'descending' },
        { text: 'Visit By', value: 'username' },
        { text: 'Time Start-End', value: 'timeStart', sortable: false },
        { text: 'Activity', value: 'timeStart', sortable: false },
      ],
      searchCompany: '',
      searchBy: {
        phase: 'PREPARATION_COMPONENT',
        progress: '',
        pctgLte: 99,
        pctgGte: 0
      }
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.editedItem.dueDate)
      }
    },
    watch: {
      searchBy: {
        async handler () {
          this.debouncedGetData()
        },
        deep: true
      },
      pagination: {
        async handler () {
          console.debug('pagination watcher')
          this.getProject()
        }
      },
      search () {
        console.debug('search watcher')
        this.debouncedGetData()
      },
      searchCompany () {
         if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
    },
    created () {
      // this.getCompanies()
      this.getUserLoginsMap()
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
      this.debouncedGetData = _.debounce(this.getProject, 500)
    },
    methods: {
      hasAttachUrl (item) {
        return !_.isEmpty(item.attachUrl)
      },
      async getUserLoginsMap () {
        try {
          let response = await this.$http.get(`/api/userlogin/all`)
          let userLogins = response.data
          this.userLoginMap = userLogins.reduce(function (map, obj) {
            map[obj.username] = obj.employee.firstName
            return map
          }, {})
        } catch (error) {
          console.log(error)
        }
      },
      async downloadBOMList (item) {
        let response = ''
        try {
          response = await axios({
            url: `/api/excel/bom-project/${item.id}`,
            method: 'GET',
            headers: {
              // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
              'Accept': '*/*'
            },
            responseType: 'blob' // important,
          })
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.refNo + '.xlsx') // or any other extension
          // document.body.appendChild(link)
          link.click()
        } catch (error) {
          console.debug(error.response)
          if (error.response.status === 422) {
            this.cancelInline('Quotation Data Not Exists')
          } else if (error.response.status === 500) {
            this.cancelInline('Error During Export xlsx')
          }
        }
      },
      hasDocLink (item) {
        return !_.isEmpty(item.docLink)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async getProject () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search || ''
          let pageNoXHR = page - 1
          let pctgLte = this.searchBy.pctgLte == '' ? 100 : this.searchBy.pctgLte
          let pctgGte = this.searchBy.pctgGte == '' ? 0 : this.searchBy.pctgGte
          let response = await this.$http.get(`/api/project?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'lastUpdateDate'}&dc=${descending || false}&q=${q}&pctglte=${pctgLte}&pctggte=${pctgGte}&prg=${this.searchBy.progress}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async getCustomers () {
        try {
          let response = await this.$http.get(`/api/customer/select?companyId=${this.editedItem.customer.company.id}`)
          this.customers = response.data
          let custobj = _.find(this.customers, ['id', this.editedItem.customer.id])
          this.editedItem.customerSelect = custobj || ''
          this.showCustomerSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },

      reset () {
        this.$refs.form1.resetValidation()
        this.resetInline()
        this.date = ''
        this.editedItem = Object.assign({}, this.defaultItem)
        this.showCustomerSelect = false
      },
      close () {
        this.dialog = false
        // this.dialog2 = false
        this.$refs.form1.resetValidation()
        // this.$refs.form2.resetValidation()
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        console.log(this.editedItem)
        this.searchCompany = this.editedItem.customer.company.name
        this.getCompaniesPaging()
        this.getCustomers()
        this.dialog = dbox
      },
      // updatePhase (item, dbox = true) {
      //   this.editedIndex = this.DataList.indexOf(item)
      //   this.editedItem = Object.assign({}, item)
      //   this.dialog2 = dbox
      // },
      async deleteItem (rec) {
        this.dialogDelete = false
        let endpoint = `api/project/${rec.id}`
        let method = 'delete'
        let s = {}

        try {
          let response = await this.$store.dispatch('updateTableItem', { endpoint, s, method })
          if (response.data.message == 'FAILED') {
            this.cancelInline(response.data.details)
            return
          }
          this.DataList.splice(this.DataList.indexOf(rec), 1)
          this.deleteInline()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      async save () {
        let tableItem = this.editedItem
        tableItem.customer = this.editedItem.customerSelect
        let index = this.editedIndex
        if (this.editedIndex > -1) {
          let endpoint = `api/project/${this.editedItem.id}`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            if (response.data.message === 'FAILED') {
              this.cancelInline(response.data.details)
              return
            }
            Object.assign(this.DataList[index], this.editedItem)
            this.saveInline()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        } else {
          let endpoint = `api/project`
          let method = 'post'
          try {
            let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            this.saveInline()
            this.getProject()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        }
        this.close()
      },
      routeLinkTo (val) {
        return `/project/overview?pid=${val.id}` // TODO ysp
      },
      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (text) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = text || 'Cancelled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      resetInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      }
    }

  }
</script>
<style>
  #projectvisitlist thead tr {
    background-color: antiquewhite;
  }

  #projectvisitlist table.v-table thead tr th {
    font-size: 1.025em;
  }
</style>
